import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { string, bool, func } from 'prop-types';

import {
  params,
  string as stringType,
  shape as shapeType,
  arrayOf as arrayType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { useStore } from '@thd-nucleus/experience-context';
import { Button } from '@thd-olt-component-react/core-ui';

import useRentalAvailability from '../hooks/useRentalAvailability';
import { CheckNearByStores } from './CheckNearbyStores/CheckNearbyStores';
import { StoreCard } from './StoreCard/StoreCard';
import { LoadingFulfillment } from './LoadingFulfillment/LoadingFulfillment';
import { WarningMessage } from './WarningMessage/WarningMessage';

import styles from './rental-fulfillment.module.scss';

export const RentalFulfillment = (props) => {
  const [opened, toggleOpened] = useState(false);
  const { handleButtonClick, itemId, showReserveNowButton } = props;

  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('rental-fulfillment.ready');
  }, []);

  const { data } = useDataModel('product', { variables: { itemId } });
  const { storeId, storeZip } = useStore();

  const {
    brandName,
    productLabel,
    rentalCategory,
    rentalSubCategory
  } = data?.product?.identifiers || {};
  const imageUrl = data?.product?.media?.image?.url;

  const { stores, isLoading, isError } = useRentalAvailability({
    rentalCategory,
    rentalSubCategory,
    storeId
  });

  const handleToggle = () => {
    toggleOpened(true);
  };

  const showFulfillmentOption = () => {
    if (stores && stores?.length !== 0 && !isLoading && !isError) {
      const localizedStore = stores.find((ls) => ls.storeId === storeId.padStart(4, '0'));
      return (
        <div className={classNames(styles['rental-fulfillment__details-container'])}>
          <StoreCard
            store={localizedStore}
          />
          <div className={classNames(styles['rental-fulfillment__options'])}>
            <span className="">
              {/* eslint-disable-next-line */}
              <a className="u__default-link check__nearstore--wrapper"
                role="link"
                data-testid="checkNearbyStores"
                onClick={handleToggle}
              >
                Check Nearby Stores
              </a>
            </span>

            { opened && (
              <CheckNearByStores
                brandName={brandName}
                clientStore={localizedStore}
                imageUrl={imageUrl}
                opened={opened}
                productLabel={productLabel}
                rentalCategory={rentalCategory}
                rentalSubCategory={rentalSubCategory}
                storeZip={storeZip}
                toggleOpened={toggleOpened}
              />
            ) }
          </div>
          { showReserveNowButton
            ? (
              <Button
                onClick={handleButtonClick}
              >
                Reserve
              </Button>
            ) : <WarningMessage /> }
        </div>
      );
    }
    return (
      <LoadingFulfillment />
    );
  };

  return (
    <div className="rental-fulfillment">
      <div className={classNames(styles['rental-fulfillment__title'])}>
        <span>&nbsp;How To Get It&nbsp;</span>
      </div>
      {showFulfillmentOption()}
    </div>
  );
};

RentalFulfillment.displayName = 'RentalFulfillment';

RentalFulfillment.propTypes = {
  handleButtonClick: func,
  itemId: string.isRequired,
  showReserveNowButton: bool
};

RentalFulfillment.defaultProps = {
  handleButtonClick: () => {},
  showReserveNowButton: true
};

RentalFulfillment.dataModel = {
  product: params({ itemId: stringType().isRequired(), dataSource: stringType() }).shape({
    dataSources: stringType(),
    itemId: stringType(),
    identifiers: shapeType({
      brandName: stringType(),
      productLabel: stringType(),
      rentalCategory: stringType(),
      rentalSubCategory: stringType()
    }),
    media: shapeType({
      image: shapeType({
        url: stringType()
      }).client(),
      images: arrayType(shapeType({
        sizes: arrayType(stringType()),
        subType: stringType(),
        type: stringType(),
        url: stringType()
      }))
    }),
  })
};
